import { Divider, Link, Stack } from '@mui/material';
import { Link as RouterLink } from 'react-router';
import { Typography } from '../../../../primitives/typography/typography';

type SignupPromptProps = {
  hideSignup?: boolean;
};

export const SignupPrompt = ({ hideSignup }: SignupPromptProps) => {
  if (hideSignup) {
    return null;
  }

  return (
    <>
      <Divider />
      <Stack
        direction="row"
        sx={{ textAlign: 'center', mt: 2, justifyContent: 'center', alignItems: 'center' }}
      >
        <Typography.Subtitle>
          Don't have an account?{' '}
          <Link
            component={RouterLink}
            to="/signup"
            underline="none"
            sx={{
              '&:link, &:visited': { color: 'primary.main' },
              '&:hover, &:active': { color: 'primary.dark' },
            }}
          >
            Sign Up
          </Link>
        </Typography.Subtitle>
      </Stack>
    </>
  );
};
